import React from "react";
import { Grid, Stack } from "@mantine/core";
import Checkbox from "@/components/atoms/Checkbox";
import styles from "../styles.module.css";
import OrderStatusEnum from "@/constants/enums/OrderStatusEnum";
import OrderTypeEnum from "@/constants/enums/OrderTypeEnum";
import SelectProductMaterial from "@/components/molecules/SelectInputs/SelectProductMaterial";
import Group from "@/components/atoms/Group";
import { useOrderStore } from "@/stores/ordersStore";
import { useTranslation } from "react-i18next";
import SortButton from "@/components/atoms/SortButton";
import MultiSelectOrderStatus from "@/components/molecules/SelectInputs/MultiSelectOrderStatus";
import MultiSelectOrderTypes from "@/components/molecules/SelectInputs/MultiSelectOrderTypes";

const OrdersFilter = () => {
  const sortDirection = useOrderStore((state) => state.sortDirection);
  const setSortDirection = useOrderStore((state) => state.setSortDirection);
  const orderTypes = useOrderStore((state) => state.orderTypes);
  const setOrderTypes = useOrderStore((state) => state.setOrderTypes);
  const statuses = useOrderStore((state) => state.statuses);
  const setStatuses = useOrderStore((state) => state.setStatuses);
  const salesItemId = useOrderStore((state) => state.salesItemId);
  const setSalesItemId = useOrderStore((state) => state.setSalesItemId);
  const awaitingProcessingOnly = useOrderStore((state) => state.awaitingProccessingOnly);
  const setAwaitingProccessingOnly = useOrderStore((state) => state.setAwaitingProccessingOnly);
  const excludeContractOrders = useOrderStore((state) => state.excludeContractOrders);
  const setExcludeContractOrders = useOrderStore((state) => state.setExcludeContractOrders);
  const includeInactive = useOrderStore((state) => state.includeInactive);
  const setIncludeInactive = useOrderStore((state) => state.setIncludeInactive);

  const changeDirection = () => {
    if (sortDirection === "ASC") {
      setSortDirection("DESC");
    } else {
      setSortDirection("ASC");
    }
  };

  const { t } = useTranslation();

  return (
    <Grid className={styles.ordersFilter} align="end">
      <Grid.Col span={2}>
        <Stack>
          <MultiSelectOrderStatus
            label={t("orders:orderStatus")}
            value={statuses}
            onChange={(val: string[]) => setStatuses(val as OrderStatusEnum[])}
          />
        </Stack>
      </Grid.Col>
      <Grid.Col span={2}>
        <MultiSelectOrderTypes
          label={t("orders:orderType")}
          value={orderTypes ? orderTypes.map((ot) => ot.toString()) : []}
          onChange={(val: any) => setOrderTypes(val as OrderTypeEnum[])}
        />
      </Grid.Col>
      <Grid.Col span={2}>
        <SelectProductMaterial
          label={t("product:material")}
          valueKey={"id"}
          labelKey={"value"}
          onChange={(val) => (val ? setSalesItemId(Number(val)) : null)}
          value={salesItemId?.toString()}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 1, lg: 4 }}>
        <SortButton onClick={() => changeDirection()} currentDirection={sortDirection} />
      </Grid.Col>
      <Grid.Col span={6}>
        <Group wrap={"wrap"} align={"flex-start"} justify={"flex-start"}>
          <Checkbox
            label={t("actions:showInactive")}
            checked={includeInactive}
            onChange={(e) => setIncludeInactive(e.target.checked)}
          />
          <Checkbox
            label={t("actions:excludeContractOrders")}
            checked={excludeContractOrders}
            onChange={(e) => setExcludeContractOrders(e.target.checked)}
          />
          <Checkbox
            label={t("actions:awaitingProcessingOnly")}
            checked={awaitingProcessingOnly}
            onChange={(e) => setAwaitingProccessingOnly(e.target.checked)}
          />
        </Group>
      </Grid.Col>
    </Grid>
  );
};

export default OrdersFilter;
